import {EventLogForm} from "../../../Components/Logging/EventLogForm";
import {EventLogResults} from "../../../Components/Logging/EventLogResults";
import {useDispatch, useSelector} from "react-redux";
import helpers from "../../../Utils/helpers";
import React, {useEffect} from "react";
import commonActions from "../../../Actions/commonActions";
import customerActions from "../../../Actions/customerActions";
import activityLogActions from "../../../Actions/InternalCustomerAdmin/activityLogActions";
import {useTranslation} from "react-i18next";
import Spinner from "../../../Components/Fundamentals/Spinner/Spinner";

export const EventLogContainer = ({ customer }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const logs = useSelector(state => state.InternalCustomerAdminReducer.eventLogs);
    const form = useSelector(state => state.CommonReducer.forms && state.CommonReducer.forms.eventLogsForm);

    const subscriptions = useSelector(state => state.CustomerReducer.subscriptions);
    const isLoading = useSelector(state => state.CommonReducer.dataLoading.eventLogs);
    
    const collaborations = useSelector(state => state.CustomerReducer.collaborations);
    
    useEffect(() => {
        if (customer?.vossCustomer && !subscriptions)
            dispatch(customerActions.searchSubscriptions(customer.vossCustomer.id));

        let controller = new AbortController();

        if (helpers.isAoCustomer(customer?.vossCustomer) && !collaborations) {
            dispatch(customerActions.getCollaborations(customer.vossCustomer.id, true, controller));
        }

        return () => {
            dispatch(activityLogActions.clear('eventLogsForm'));
            dispatch(activityLogActions.clear('eventLogs'));
            controller.abort();
        }
    }, []);
    
    useEffect(() => {
        dispatch(commonActions.startFormEditing('eventLogsForm', {
            clientId: null,
            subscriptionId: null,
            customerId: customer?.vossCustomer?.id ?? null,
            fromDate: helpers.getCurrentDate(),
            toDate: helpers.getCurrentDate()
        }));

        return () => {
            dispatch(commonActions.cancelFormEditing('eventLogsForm'));
        }
    }, []);
        
    return (
        <>
            {form && <EventLogForm form={form} customer={customer} subscriptions={subscriptions} collaborations={collaborations} />}
            {isLoading ? <Spinner/> : logs && <EventLogResults logs={logs}/>}
        </>
    )
}